import { Component, OnInit } from '@angular/core';
import { MailCode } from '../core/enums/mail-code.enum';
import { MailTemplateService } from '../core/services/mail-template.service';
import { MailTemplate } from '../core/models/mail-template.model';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-mail-template',
  templateUrl: './mail-template.component.html',
  styleUrls: ['./mail-template.component.css']
})
export class MailTemplateComponent implements OnInit {

  code: string;
  editorSettings: any;
  loading: boolean;
  template: string;

  private mailTemplate: MailTemplate;

  constructor(private route: ActivatedRoute, private service: MailTemplateService) { }

  get pristine(): boolean {
    return this.template === this.mailTemplate.TEMPLATE;
  }

  get templateName(): string {
    return MailCode[this.code as keyof typeof MailCode];
  }

  ngOnInit(): void {
    this.editorSettings = {
      content_css: 'styles.css',
      font_family_formats: 'Andale Mono=andale mono,monospace; Arial=arial,helvetica,sans-serif; Arial Black=arial black,sans-serif; Book Antiqua=book antiqua,palatino,serif; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier,monospace; Delivery=Delivery; Georgia=georgia,palatino,serif; Helvetica=helvetica,arial,sans-serif; Impact=impact,sans-serif; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco,monospace; Times New Roman=times new roman,times,serif; Trebuchet MS=trebuchet ms,geneva,sans-serif; Verdana=verdana,geneva,sans-serif; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
      height: 650,
      plugins: ['charmap', 'fullscreen', 'help', 'image', 'insertdatetime', 'link', 'lists', 'preview', 'table', 'searchreplace', 'visualblocks', 'visualchars', 'wordcount'],
      promotion: false,
      toolbar1: 'undo redo | fontfamily fontsize | removeformat | bullist numlist | outdent indent | visualchars | help',
      toolbar2: 'bold italic underline strikethrough subscript superscript | backcolor forecolor |\
       alignleft aligncenter alignright alignjustify | lineheight | table'
    };

    this.route.params.subscribe((params: Params) => {
      this.code = params.code;

      this.loading = true;
      this.service.get(this.code).subscribe((mailTemplate: MailTemplate) => {
        this.mailTemplate = mailTemplate;
        this.template = mailTemplate.TEMPLATE;
        this.loading = false;
      });

    })
  }

  onSave() {
    this.loading = true;
    this.service.update(this.template, this.code).subscribe((mailTemplate: MailTemplate) => {
      this.mailTemplate = mailTemplate;
      this.template = mailTemplate.TEMPLATE;
      this.loading = false;
    });
  }

}
